
const digest = '50b5c5bbd8dde4919becba2b6cffdcd3eef6bd8db6bf54ae1887f60b23740169';
const classes = {"wrapper":"_wrapper_1dt4f_1","filterWrapper":"_filterWrapper_1dt4f_10","contentWrapper":"_contentWrapper_1dt4f_15","loadingWrapper":"_loadingWrapper_1dt4f_18","controls":"_controls_1dt4f_22","content":"_content_1dt4f_15","paginator":"_paginator_1dt4f_32"};
const css = `._wrapper_1dt4f_1 {
  display: flex;
  flex-direction: row;
  font-family: Rubik, "sans-serif";
  flex-grow: 1;
  height: 100%;
  border: 1px solid #eaedf3;
  background-color: #ffffff;
}
._wrapper_1dt4f_1 ._filterWrapper_1dt4f_10 {
  display: flex;
  flex-direction: column;
  position: relative;
}
._wrapper_1dt4f_1 ._contentWrapper_1dt4f_15 {
  flex: 1;
}
._wrapper_1dt4f_1 ._contentWrapper_1dt4f_15 ._loadingWrapper_1dt4f_18 {
  height: 100%;
  padding: 12px;
}
._wrapper_1dt4f_1 ._contentWrapper_1dt4f_15 ._controls_1dt4f_22 {
  border-bottom: 1px solid #e2e5ed;
  padding: 12px;
  gap: 15px;
  display: flex;
  justify-content: space-between;
}
._wrapper_1dt4f_1 ._contentWrapper_1dt4f_15 ._content_1dt4f_15 {
  flex: 1;
}
._wrapper_1dt4f_1 ._contentWrapper_1dt4f_15 ._content_1dt4f_15 ._paginator_1dt4f_32 {
  border-bottom: 1px solid #e2e5ed;
  padding: 12px;
  gap: 15px;
  display: flex;
  justify-content: space-between;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  